// @flow
import {
  UPDATE_PRODUCT_PERFORMANCE_RANKING_FAILURE,
  UPDATE_PRODUCT_PERFORMANCE_RANKING_REQUEST,
  UPDATE_PRODUCT_PERFORMANCE_RANKING_SUCCESS,
  GET_PRODUCT_PERFORMANCE_RANKING_FAILURE,
  GET_PRODUCT_PERFORMANCE_RANKING_REQUEST,
  GET_PRODUCT_PERFORMANCE_RANKING_SUCCESS,
  ProductPerformanceRankingAction,
  ProductPerformanceRankingState
} from 'stores/flow-type/product-performance-ranking.type';

const initialState: ProductPerformanceRankingState = {
  updating: false,
  loading: false,
  success: false,
  settings: {}
};

const performanceRankingReducers = (
  state: ProductPerformanceRankingState = initialState,
  action: ProductPerformanceRankingAction
) => {
  switch (action.type) {
    // Get product performance ranking
    case GET_PRODUCT_PERFORMANCE_RANKING_REQUEST:
      return { ...state, loading: true };
    case GET_PRODUCT_PERFORMANCE_RANKING_SUCCESS: {
      return {
        ...state,
        loading: false,
        settings: action.payload.data || {},
        error: undefined
      };
    }
    case GET_PRODUCT_PERFORMANCE_RANKING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    // Update product performance ranking
    case UPDATE_PRODUCT_PERFORMANCE_RANKING_REQUEST:
      return { ...state, updating: true, success: false };
    case UPDATE_PRODUCT_PERFORMANCE_RANKING_SUCCESS: {
      return {
        ...state,
        updating: false,
        success: true,
        settings: action.payload.data || {},
        error: undefined
      };
    }
    case UPDATE_PRODUCT_PERFORMANCE_RANKING_FAILURE:
      return {
        ...state,
        updating: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default performanceRankingReducers;
